import { isRejectedWithValue } from '@reduxjs/toolkit';

import { setGlobalError } from '../slices/globalErrorSlice';

const globalErrorMiddleware = (store) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const errorData = action.payload?.response?.data || {
      message: 'An unexpected error occurred',
      statusCode: 500,
    };
    store.dispatch(setGlobalError(errorData));
  }

  return next(action);
};

export default globalErrorMiddleware;
